{
  "WALLBOARD": {
    "LOADING": "Loading phone queues...",
    "NO_QUEUES": "No phone queues found.",
    "AGENTS": "Agents",
    "NO_AGENTS": "No online agents in this queue.",
    "NO_AGENTS_ONLINE": "No online agents.",
    "WAITING_CALLERS": "Waiting Callers",
    "NO_CALLERS": "No waiting callers.",
    "UNKNOWN_CALLER": "Unknown Caller",
    "POSITION": "Position",
    "STATUS": "Status",
    "TIME": "Time",
    "AGENT": "Agent",
    "EXTENSION": "Extension",
    "AVAILABLE": "Available",
    "READY": "Ready Agents",
    "ON_CALL": "Agents On Call",
    "QUEUE_CALL": "Queue Call",
    "OTHER_CALL": "Other Call",
    "PAUSED": "Agents on Break",
    "WAITING": "Waiting calls",
    "MISSED_CALLS": "Missed calls",
    "HANDLED_CALLS": "Handled incoming calls",
    "OUTBOUND_CALLS": "Handled outbound calls",
    "AVAILABILITY": "Availability",
    "AVAILABILITY_TOOLTIP": "Percentage of inbound calls answered by agents (calls that were picked up)",
    "TOTAL": "total",
    "AGENTS_COUNT": "({onCall} on call / {total} total)",
    "NO_AVAILABLE": "(nobody online)",
    "WAITING_CALLERS_COUNT": "{count} waiting",
    "CALLER": "Caller",
    "NUMBER": "Number",
    "WAIT_TIME": "Wait Time",
    "QUEUES": "Queues",
    "ACTION": "Action",
    "PICKUP_CALL": "Pick up",
    "PICKING_UP": "Picking up...",
    "PICKUP_SUCCESS": "Call pickup requested successfully.",
    "PICKUP_ERROR": "Failed to pick up the call. Please try again.",
    "PICKUP_DISABLED_TOOLTIP": "You cannot pick up a call while on a call or offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "No access"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "No access"
    }
  }
}